module.exports = __webpack_public_path__ + "static/img/fingerpost_refund_7.4c1e418.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_refund_7.jpg
// module id = sW0l
// module chunks = 0